//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { FulfillmentType } from '@apis/campaign-requests/sampling/campaign-requests/samplingCampaignRequestsApiModel';

export enum SamplingCampaignRequestSectionName {
  PRODUCTS = 'products',
  AUDIENCE = 'audience',
  TASKS = 'tasks',
  PACKAGING = 'packaging',
  FULFILLMENT = 'fulfillment',
  PURCHASE_OPTIONS = 'purchase-options',
  SUMMARY = 'summary',
}

export const getSamplingCampaignRequestSectionDisplayNames = (
  fulfillmentType?: FulfillmentType,
): Record<SamplingCampaignRequestSectionName, string> => {
  return {
    [SamplingCampaignRequestSectionName.PRODUCTS]: 'Products',
    [SamplingCampaignRequestSectionName.AUDIENCE]: 'Audience',
    [SamplingCampaignRequestSectionName.TASKS]: 'Content',
    [SamplingCampaignRequestSectionName.PACKAGING]: 'Packaging',
    [SamplingCampaignRequestSectionName.FULFILLMENT]:
      fulfillmentType === 'deals' ? 'Deals' : 'Shipping',
    [SamplingCampaignRequestSectionName.PURCHASE_OPTIONS]: 'Purchase Options',
    [SamplingCampaignRequestSectionName.SUMMARY]: 'Summary',
  };
};

export const getSamplingCampaignSectionDisplayName = (
  sectionKey: SamplingCampaignRequestSectionName,
  fulfillmentType?: FulfillmentType,
): string => {
  const sectionDisplayNames =
    getSamplingCampaignRequestSectionDisplayNames(fulfillmentType);

  return sectionDisplayNames[sectionKey];
};
